import { useRef } from "react";
import { Bold, List, ListOrdered, Pilcrow } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function TermsEditor({ value, onChange, testid = "terms-editor", rows = 8, placeholder }) {
  const ref = useRef(null);

  const wrapBold = () => {
    const ta = ref.current;
    if (!ta) return;
    const { selectionStart: s, selectionEnd: e } = ta;
    const sel = value.slice(s, e) || "bold text";
    onChange(value.slice(0, s) + `**${sel}**` + value.slice(e));
    requestAnimationFrame(() => { ta.focus(); ta.setSelectionRange(s + 2, s + 2 + sel.length); });
  };
  const insertLine = (prefix) => {
    const ta = ref.current;
    const pos = ta ? ta.selectionStart : value.length;
    const lineStart = value.lastIndexOf("\n", pos - 1) + 1;
    onChange(value.slice(0, lineStart) + prefix + value.slice(lineStart));
    requestAnimationFrame(() => ta?.focus());
  };
  const numbered = () => {
    const lines = value.split("\n").filter((l) => l.trim());
    insertLine(`${lines.filter((l) => /^\d+\.\s/.test(l.trim())).length + 1}. `);
  };

  return (
    <div data-testid={testid}>
      <div className="mb-1 flex gap-1 rounded-t-md border border-b-0 bg-slate-50 px-2 py-1">
        <Button type="button" variant="ghost" size="icon" className="h-7 w-7" data-testid={`${testid}-bold`} onClick={wrapBold} title="Bold"><Bold className="h-3.5 w-3.5" /></Button>
        <Button type="button" variant="ghost" size="icon" className="h-7 w-7" data-testid={`${testid}-numbered`} onClick={numbered} title="Numbered list"><ListOrdered className="h-3.5 w-3.5" /></Button>
        <Button type="button" variant="ghost" size="icon" className="h-7 w-7" data-testid={`${testid}-bullet`} onClick={() => insertLine("• ")} title="Bullet"><List className="h-3.5 w-3.5" /></Button>
        <Button type="button" variant="ghost" size="icon" className="h-7 w-7" data-testid={`${testid}-paragraph`} onClick={() => onChange(value + "\n\n")} title="Paragraph break"><Pilcrow className="h-3.5 w-3.5" /></Button>
      </div>
      <Textarea ref={ref} rows={rows} data-testid={`${testid}-input`} className="rounded-t-none font-mono text-[13px]"
        placeholder={placeholder || "1. Prices should remain valid for 30 days.\n2. Delivery must be completed within the specified timeline.\n3. Material must comply with the attached specifications."}
        value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

export function TermsView({ text, testid = "terms-view" }) {
  if (!text) return null;
  return (
    <div className="whitespace-pre-wrap rounded-md border bg-slate-50 p-3 text-sm" data-testid={testid}>
      {text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
        part.startsWith("**") && part.endsWith("**")
          ? <strong key={i}>{part.slice(2, -2)}</strong>
          : <span key={i}>{part}</span>)}
    </div>
  );
}
